import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import {
    visibleAssetsMarkersSelector,
    detailViewSelector, removeDetailView,
    selectVehiclesByIds,
} from '../../../features/assets/assetsSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const OsmMapAssetBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const focusedAsset = useSelector(detailViewSelector);
    const visibleVehicles = useSelector(state => selectVehiclesByIds(state, visibleAssetMarkers));

    useEffect(() => {
        const mapBounder = () => {
            if (map && !focusedAsset && visibleAssetMarkers.length > 0) {
                let pointArray = [];
                visibleVehicles.forEach((vehicle) => {
                    if (vehicle && vehicle.coreData) {
                        pointArray.push([vehicle.coreData.lat, vehicle.coreData.lng]);
                    }
                });
                //map.fitBounds(pointArray, { left: 350, bottom: 100, top: 75, right: 25 });
                map.fitBounds(pointArray, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                //console.log("Asset bounded");
                dispatch(setNeedBounding(false));
            }
        };

        dispatch(removeDetailView());
        mapBounder();
    }, [visibleAssetMarkers, dispatch, focusedAsset, map, visibleVehicles]);


    return (
        <div></div>
    );
}

export default OsmMapAssetBounder;